import { render, staticRenderFns } from "./Viewuploadedfiles.vue?vue&type=template&id=af1ac9a0&scoped=true&"
import script from "./Viewuploadedfiles.vue?vue&type=script&lang=js&"
export * from "./Viewuploadedfiles.vue?vue&type=script&lang=js&"
import style0 from "./Viewuploadedfiles.vue?vue&type=style&index=0&id=af1ac9a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1ac9a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af1ac9a0')) {
      api.createRecord('af1ac9a0', component.options)
    } else {
      api.reload('af1ac9a0', component.options)
    }
    module.hot.accept("./Viewuploadedfiles.vue?vue&type=template&id=af1ac9a0&scoped=true&", function () {
      api.rerender('af1ac9a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadFile/Viewuploadedfiles.vue"
export default component.exports